/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2024, Zumper
 * @description NewPressSection
 */

import { Flex, Heading, Image, Link, SimpleGrid } from '@chakra-ui/react'
import { PRESS_IMPRESSION } from '@zcode-ui/web-zumper-integrations'
import { HOMEPAGE } from '@zcode/mixpanel'
import * as React from 'react'
import { useHomepageImpression } from '../hooks/useHomepageImpression'
import { PRESS_OUTLETS } from './constants'

const PressSection = () => {
  const ref = useHomepageImpression({ name: PRESS_IMPRESSION, mixpanelSection: HOMEPAGE.PRESS })
  return (
    <Flex ref={ref} gap={10} width="full" flexDir="column">
      <Flex
        justifyContent="space-between"
        width="full"
        flexDir={{ base: 'column', desktop: 'row' }}
        gap={4}
        alignItems={{ desktop: 'center' }}
      >
        <Heading variant="display28To32">Find us in the press</Heading>
        <Link href="/newsroom" color="blue.800" fontWeight="medium">
          Visit the newsroom
        </Link>
      </Flex>
      <SimpleGrid columns={{ base: 2, desktop: 5 }} spacing={{ base: 4, desktop: 6 }}>
        {PRESS_OUTLETS.map((item) => (
          <Image src={item.img} alt={`${item.label} logo`} key={item.label} width="full" />
        ))}
      </SimpleGrid>
    </Flex>
  )
}

export default PressSection
